{
  "list": {
    "title": "Frasa Pintar",
    "backToDashboard": "Papan Pemuka",
    "newButton": "Frasa Baharu",
    "import": "Import",
    "export": "Eksport",
    "searchPlaceholder": "Cari mengikut kunci atau teks pengembangan...",
    "filterAllCategories": "Semua Kategori",
    "header": "Frasa ({{count}})",
    "loading": "Memuatkan frasa...",
    "empty": "Tiada frasa ditemui. Cipta frasa pintar pertama anda.",
    "authoredBy": "oleh {{name}}",
    "tooltips": {
      "preview": "Pratonton",
      "edit": "Sunting",
      "delete": "Padam"
    },
    "confirmDelete": "Sahkan",
    "cancelDelete": "Batal",
    "previewLabel": "Pratonton:",
    "closePreview": "Tutup pratonton",
    "toast": {
      "deleted": "Frasa dipadam",
      "importComingSoon": "Fungsi import akan datang",
      "exportComingSoon": "Fungsi eksport akan datang"
    }
  },
  "form": {
    "editTitle": "Sunting Frasa Pintar",
    "createTitle": "Frasa Pintar Baharu",
    "fields": {
      "key": "Kunci",
      "category": "Kategori",
      "expansionText": "Teks Pengembangan"
    },
    "required": "*",
    "keyPlaceholder": ".normalexam",
    "keyHelper": "Mesti bermula dengan \".\"",
    "categoryUncategorized": "Tanpa Kategori",
    "expansionPlaceholder": "Teks yang akan menggantikan pintasan...",
    "cancel": "Batal",
    "create": "Cipta Frasa",
    "update": "Kemas Kini Frasa",
    "toast": {
      "created": "Frasa dicipta",
      "updated": "Frasa dikemas kini",
      "saveFailed": "Gagal menyimpan frasa",
      "keyMustStartWithDot": "Kunci mesti bermula dengan \".\"",
      "keyTooShort": "Kunci mesti sekurang-kurangnya 2 aksara",
      "expansionRequired": "Teks pengembangan diperlukan"
    }
  },
  "category": {
    "general": "Umum",
    "physicalExam": "Pemeriksaan Fizikal",
    "reviewOfSystems": "Tinjauan Sistem",
    "assessment": "Penilaian",
    "plan": "Pelan",
    "instructions": "Arahan",
    "medications": "Ubat",
    "history": "Sejarah Perubatan"
  }
}
